const InfoBoxRow = ({
  children,
  title
}: {
  children: React.ReactNode,
  title: string
}) => {
  return (
    <div className="flex gap-[var(--spacing-sm)]">
      <h4 style={{ font: "var(--font-h4)", width: "120px" }}>{title}</h4>
      <div className="flex flex-col gap-[var(--spacing-sm)]">
        {children}
      </div>
    </div>
  )
}

export default InfoBoxRow